import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {NumberField} from "../../number-input";


export function FieldTableNumberColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'number',
            width: () => 'minmax(5em,max-content)',
            className: () => 'column-int',
            renderViewer: (props: FieldRendererProps<any,any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return value;
            },
            renderEditor: (props: FieldRendererProps<any,any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                const onChange = props.options?.onChange? (evt)=>{props.options.onChange(evt,props); }:props.field.onChange;
                return (<NumberField autoSize={true} {...props.field} value={value} onChange={onChange} autoFocus={true} style={{textAlign:'right'}} />);
            },
            renderExport:(cell,props: FieldRendererProps<any,any>):any => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if(props?.options?.exportFormat =='percentage') {
                    cell.t = 'n';
                    cell.z = '#.##"%"';
                    cell.v = value;
                    if (typeof value == 'number') {
                        cell.v = value / 100;
                    }
                    if (typeof value == 'string') {
                        cell.v = parseFloat(value ? value.replace('%', '') : '');
                    }
                    if(isNaN(cell.v)||cell.v==null) { 
                        cell.v = 0;
                    }
                    return cell;
                }
                cell.t = 'n';
                cell.v = value;
                if(isNaN(value)||value===null) {
                    cell.v = 0;
                }
                return cell;
            }
        });
    }, [context]);
    return null;
}
